import angular from 'angular';
import brandingUploads from './brandingUploads';

export default angular.module('mycrmThemeBranding.scenes', [brandingUploads])
  .name;
